export default __webpack_public_path__ + "static/media/cyl3dslice.9c5fd8f7.jpg";